import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-24">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="mt-2 text-zinc-500">
        The resource you are looking for does not exist.
      </p>
      <Button variant="outline" className="mt-6" onClick={() => navigate(-1)}>
        Go back
      </Button>
    </div>
  );
}
